import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d660cb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "server-evaluation" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-title" }, "服务评价", -1))
const _hoisted_4 = { class: "item-evaluation-edit" }
const _hoisted_5 = { class: "star-box" }
const _hoisted_6 = { class: "star-description" }
const _hoisted_7 = { class: "star" }
const _hoisted_8 = {
  key: 1,
  class: "item"
}
const _hoisted_9 = { class: "item-title title-view-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "服务评价", -1))
const _hoisted_11 = { class: "time" }
const _hoisted_12 = { class: "item-evaluation-view" }
const _hoisted_13 = { class: "star-box" }
const _hoisted_14 = { class: "star-description" }
const _hoisted_15 = { class: "star" }
const _hoisted_16 = { class: "descption" }
const _hoisted_17 = {
  key: 0,
  class: "operator xag-page__footer"
}

import AppHeader from '@/components/Header.vue'
import appHost from '@/utils/app'
import { useRouter, useRoute } from 'vue-router'
import { computed, onBeforeMount, ref } from 'vue'
import { Button, Rate, Field, Toast } from 'vant'
import { starEvaluation } from '@/defination/complete-machine-delivery'
import { getTicketDetail, setTicketEvaluation } from '@/apis/complete-machine-delivery'

export default /*#__PURE__*/_defineComponent({
  __name: 'delivery-service-evaluation',
  setup(__props) {

const Router = useRouter()
const Route = useRoute()
let type = ref(Route.query.type)
let isEdit = computed({
  get() {
    return type.value === 'edit'
  },
  set(value) {
    if (value) {
      type.value = 'edit'
    } else {
      type.value = 'detail'
    }
  },
})

const onLeftClick = function () {
  // appHost.goAppBack()
  Router.go(-1)
}
let rateValue = ref(-1)
let rateValueText = ref('满意程度')
let descption = ref('')
let time = ref('')
const rateChangeHandler = (value: number) => {
  rateValueText.value = starEvaluation.get(value)
}

async function initData() {
  if (!isEdit.value) {
    // 获取详细
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0,
    })
    let data = await getTicketDetail({
      order_no: Route.query.order_no as string,
    })
    rateValue.value = Number(data.assess_info.score)
    rateValueText.value = starEvaluation.get(Number(data.assess_info.score))
    descption.value = data.assess_info.explain
    time.value = data.assess_info.created_at
    console.log('data', data)
    Toast.clear()
  }
}
async function confirmHandler() {
  Toast.loading('提交中...')
  if (rateValue.value === -1) {
    Toast('请对服务进行评分')
    return
  }
  try {
    await setTicketEvaluation({
      order_no: Route.query.order_no as string,
      score: String(rateValue.value),
      explain: descption.value,
    })
    Toast.success('评价成功！')
    successHanlder()
  } catch (e) {
    Toast.fail(e)
    console.log(e)
  }
}
function successHanlder() {
  console.log('successHanlder')
  isEdit.value = false
}
onBeforeMount(async () => {
  await initData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "评价",
      onLeftClick: onLeftClick,
      isReturnLeftEvent: ""
    }),
    _createElementVNode("div", _hoisted_1, [
      (_unref(isEdit))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(rateValueText)), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(Rate), {
                    modelValue: _unref(rateValue),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(rateValue) ? (rateValue).value = $event : rateValue = $event)),
                    size: 40,
                    onChange: rateChangeHandler,
                    color: "#ffd21e",
                    "void-icon": "star",
                    "void-color": "#eee"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode(_unref(Field), {
                class: "descption",
                modelValue: _unref(descption),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(descption) ? (descption).value = $event : descption = $event)),
                rows: "7",
                autosize: "",
                type: "textarea",
                maxlength: "150",
                placeholder: "请描述实际服务体验",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(time)), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(rateValueText)), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_unref(Rate), {
                    modelValue: _unref(rateValue),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(rateValue) ? (rateValue).value = $event : rateValue = $event)),
                    size: 40,
                    readonly: true,
                    onChange: rateChangeHandler,
                    color: "#ffd21e",
                    "void-icon": "star",
                    "void-color": "#eee"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(descption)), 1)
            ])
          ]))
    ]),
    (_unref(isEdit))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_unref(Button), {
            class: "confirm-button",
            onClick: confirmHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})